export default class Checkout {

  constructor() {
      this.hasIncetivedProject = false;
  }

}